import { IdentifierDTO } from '@zazume/zzm-base';
import { PriceVO } from '@zazume/zzm-utils';

interface ConstructorParams {
  totalPaid: PriceVO;
  totalFeePaid: PriceVO;
  incomeIds?: IdentifierDTO[];
}

export class RentAdvanceProgress {
  totalPaid: PriceVO;
  totalFeePaid: PriceVO;
  incomeIds: IdentifierDTO[];

  constructor(params: ConstructorParams) {
    this.totalPaid = params.totalPaid;
    this.totalFeePaid = params.totalFeePaid;
    this.incomeIds = params.incomeIds ?? [];
  }
}
